// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCxXbRnQulAx0oR9LBexbesGz3IEamz6jA",
  authDomain: "burimi-drivingschool.firebaseapp.com",
  projectId: "burimi-drivingschool",
  storageBucket: "burimi-drivingschool.firebasestorage.app",
  messagingSenderId: "1082841568170",
  appId: "1:1082841568170:web:472de22f6132cd050251d3",
  measurementId: "G-2EL6T6QRCR",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);

export { app, analytics, auth, db };
